

import {image} from 'suneditor/src/plugins'
import ReactDOM from "react-dom";
import React from "react";
import OsMediaLibrary, {OsFileManager} from "../media-library/plugin";

export const imagePlugin = {
    ...image,
    onClickMediaLibrary (context) {

        const dialog = document.createElement("DIV");
        dialog.className = "media-library-modal os-media-library-content-wrapper";

        document.body.appendChild(dialog);
        ReactDOM.render( (<OsFileManager
            onSave={(value)=>{
                this.onSaveMediaLibraryFile(value)
                ReactDOM.unmountComponentAtNode(dialog);
                dialog.remove();
            }}
            onCloseModal={()=>{
                ReactDOM.unmountComponentAtNode(dialog);
                dialog.remove();
            }}
            labels={OsMediaLibrary.labels_by_langs.ua}
        />), dialog );
    },
    onSaveMediaLibraryFile(fileUrl){
        const input  = document.querySelector('._se_image_url')
        if(input){
            input.focus();
            const setter = Object.getOwnPropertyDescriptor(
                HTMLInputElement.prototype,
                'value'
            )?.set;

            setter?.call(input, fileUrl);

            input.dispatchEvent(new InputEvent('input', {
                bubbles: true,
                inputType: 'insertText',
                data: fileUrl,
            }));

            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    },
    setDialog: function (core) {
        const option = core.options;
        const lang = core.lang;
        const dialog = core.util.createElement('DIV');

        dialog.className = 'se-dialog-content se-dialog-image';
        dialog.style.display = 'none';

        let html = '' +
            '<div class="se-dialog-header">' +
            '<button type="button" data-command="close" class="se-btn se-dialog-close" class="close" title="' + lang.dialogBox.close + '" aria-label="' + lang.dialogBox.close + '">' +
            core.icons.cancel +
            '</button>' +
            '<span class="se-modal-title">' + lang.dialogBox.imageBox.title + '</span>' +
            '</div>' +
            '<div class="se-dialog-tabs">' +
            '<button type="button" class="_se_tab_link active" data-tab-link="image">' + lang.toolbar.image + '</button>' +
            '<button type="button" class="_se_tab_link" data-tab-link="url">' + lang.toolbar.link + '</button>' +
            '</div>' +
            '<form method="post" enctype="multipart/form-data">' +
            '<div class="_se_tab_content _se_tab_content_image">' +
            '<div class="se-dialog-body"><div style="border-bottom: 1px dashed #ccc;">';

        if (option.imageFileInput) {
            html += '' +
                '<div class="se-dialog-form">' +
                '<label>' + lang.dialogBox.imageBox.file + '</label>' +
                '<div class="se-dialog-form-files">' +
                '<input class="se-input-form _se_image_file" type="file" accept="' + option.imageAccept + '"' + (option.imageMultipleFile ? ' multiple="multiple"' : '') + '/>' +
                '<button type="button" class="se-btn se-dialog-files-edge-button se-file-remove" title="' + lang.controller.remove + '" aria-label="' + lang.controller.remove + '">' + core.icons.cancel + '</button>' +
                '</div>' +
                '</div>' ;
        }

        if (option.imageUrlInput) {
            html += '' +
                '<div class="se-dialog-form">' +
                '<label>' + lang.dialogBox.imageBox.url + '</label>' +
                '<div class="se-dialog-form-files">' +
                `<div id="media-library-image-btn" style="margin-right: 10px"><span><span class="fa fa-folder-open"></span></div>` +
                '<input class="se-input-form se-input-url _se_image_url" type="text" />' +
                ((option.imageGalleryUrl && core.plugins.imageGallery) ? '<button type="button" class="se-btn se-dialog-files-edge-button __se__gallery" title="' + lang.toolbar.imageGallery + '" aria-label="' + lang.toolbar.imageGallery + '">' + core.icons.image_gallery + '</button>' : '') +
                '</div>' +
                '<pre class="se-link-preview"></pre>' +
                '</div>';
        }

        html += '</div>' +
            '<div class="se-dialog-form">' +
            '<label>' + lang.dialogBox.imageBox.altText + '</label><input class="se-input-form _se_image_alt" type="text" />' +
            '</div>';

        if (option.imageResizing) {
            const onlyPercentage = option.imageSizeOnlyPercentage;
            const onlyPercentDisplay = onlyPercentage ? ' style="display: none !important;"' : '';
            const heightDisplay = !option.imageHeightShow ? ' style="display: none !important;"' : '';
            html += '<div class="se-dialog-form">';
            if (onlyPercentage || !option.imageHeightShow) {
                html += '' +
                    '<div class="se-dialog-size-text">' +
                    '<label class="size-w">' + lang.dialogBox.size + '</label>' +
                    '</div>';
            } else {
                html += '' +
                    '<div class="se-dialog-size-text">' +
                    '<label class="size-w">' + lang.dialogBox.width + '</label>' +
                    '<label class="se-dialog-size-x">&nbsp;</label>' +
                    '<label class="size-h">' + lang.dialogBox.height + '</label>' +
                    '</div>';
            }
            html += '' +
                '<input class="se-input-control _se_image_size_x" placeholder="auto"' + (onlyPercentage ? ' type="number" min="1"' : 'type="text"') + (onlyPercentage ? ' max="100"' : '') + ' />' +
                '<label class="se-dialog-size-x"' + heightDisplay + '>' + (onlyPercentage ? '%' : 'x') + '</label>' +
                '<input type="text" class="se-input-control _se_image_size_y" placeholder="auto"' + onlyPercentDisplay + (onlyPercentage ? ' max="100"' : '') + heightDisplay + '/>' +
                '<label' + onlyPercentDisplay + heightDisplay + '><input type="checkbox" class="se-dialog-btn-check _se_image_check_proportion" checked/>&nbsp;' + lang.dialogBox.proportion + '</label>' +
                '<button type="button" title="' + lang.dialogBox.revertButton + '" aria-label="' + lang.dialogBox.revertButton + '" class="se-btn se-dialog-btn-revert" style="float: right;">' + core.icons.revert + '</button>' +
                '</div>' ;
        }


        html += '' +
            '<div class="se-dialog-form se-dialog-form-footer">' +
            '<label><input type="checkbox" class="se-dialog-btn-check _se_image_check_caption" />&nbsp;' + lang.dialogBox.caption + '</label>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="_se_tab_content _se_tab_content_url" style="display: none">' +
            core.context.anchor.forms.innerHTML +
            '</div>' +
            '<div class="se-dialog-footer">' +
            '<div' + (option.imageAlignShow ? '' : ' style="display: none"') + '>' +
            '<label><input type="radio" name="suneditor_image_radio" class="se-dialog-btn-radio" value="none" checked>' + lang.dialogBox.basic + '</label>' +
            '<label><input type="radio" name="suneditor_image_radio" class="se-dialog-btn-radio" value="left">' + lang.dialogBox.left + '</label>' +
            '<label><input type="radio" name="suneditor_image_radio" class="se-dialog-btn-radio" value="center">' + lang.dialogBox.center + '</label>' +
            '<label><input type="radio" name="suneditor_image_radio" class="se-dialog-btn-radio" value="right">' + lang.dialogBox.right + '</label>' +
            '</div>' +
            '<button type="submit" class="se-btn-primary" title="' + lang.dialogBox.submitButton + '" aria-label="' + lang.dialogBox.submitButton + '"><span>' + lang.dialogBox.submitButton + '</span></button>' +
            '</div>' +
            '</form>';



        dialog.innerHTML = html;

      setTimeout(()=>{
          const btn = document.getElementById('media-library-image-btn')
          if(btn){
              btn.addEventListener('click', e => {
                  e.preventDefault()
                  this.onClickMediaLibrary()
              })
          }
      },500)

        return dialog;
    },
}